/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { error } from '@/libs/notification';
import { handleAuthorizationError } from '@/libs/apiErrorHandler';
import { getAccessToken } from '@/libs/firebaseAuth';
import { getBaseUrl } from '@/libs/env';

export default {
  namespaced: true,
  state: {
    listData: [],
    loading: false
  },
  mutations: {
    setListData(state: any, payload: any[]) {
      state.listData = payload;
    },
    setLoading(state: any, payload: boolean) {
      state.loading = payload;
    }
  },
  actions: {
    async fetch(context: any) {
      context.commit('setLoading', true);
      try {
        const { data } = await axios.get(
          getBaseUrl() + '/master/mccs/properties',
          {
            headers: { auth: await getAccessToken() }
          }
        );
        context.commit('setListData', data);
      } catch (e: any) {
        if (e.response && e.response.status === 401) {
          await handleAuthorizationError();
        } else {
          error(e.response?.status || '', 'データ取得に失敗しました');
        }
      } finally {
        context.commit('setLoading', false);
      }
    },
    async create(context: any, newRows: any[]) {
      await axios.post(getBaseUrl() + '/master/mccs/properties/bulk', newRows, {
        headers: { auth: await getAccessToken() }
      });
    },
    async update(context: any, updateRows: any[]) {
      await axios.patch(
        getBaseUrl() + '/master/mccs/properties/bulk',
        updateRows,
        {
          headers: { auth: await getAccessToken() }
        }
      );
    },
    async delete(context: any, ids: (number | string)[]) {
      await axios.post(
        getBaseUrl() + '/master/mccs/properties/bulk/delete',
        ids,
        {
          headers: { auth: await getAccessToken() }
        }
      );
    }
  }
};
